import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './RegistrationRequest';

export class Welcome extends BaseElement {
	constructor() {
		super();

		this.library.add(faQuestionCircle);
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: flex;
					flex-flow: row wrap;
				}
				:host > div {
					flex: 1;
					margin: 0.25em;
					min-width: 15em;
				}
				.links {
					display: flex;
					flex-flow: row wrap;
					justify-content: center;
				}
				.links > * {
					text-align: center;
					flex: 1;
					margin: 0.5em;
					min-width: 10em;
					max-width: 15em;
				}
			`
		];
	}
	render() {
		return html`
			<div>
				<h4>Welcome to the Kinex Connect Physician Portal.</h4>
				<p>This portal is used to provide usage analytics of patients using the Kinex Connect Knee CPM. The information presented herein is presented in real-time.  Reports can be downloaded as PDFs for easy addition to your EHR platform.</p>
				<div class="links">
					<a class="button" target="_blank" href="https://kinexmedical.com/kinex-connect/patient-data/">
						<i class="icon fas fa-question-circle"></i> Understanding &amp;<br/>
						Accessing Patient Data
					</a>
					<a class="button" target="_blank" href="https://kinexmedical.com/kinex-connect/settings-notifications/">
						<i class="icon fas fa-question-circle"></i> Controlling Settings <br/>
						&amp; Notifications
					</a>
				</div>
			</div>
			<div>
				<pp-registration-request></pp-registration-request>
			</div>
		`;
	}
}

customElements.define('pp-welcome', Welcome);